import './LoginPage.css';
import LoginForm from './components/login-form';
import { TextField } from '../../../../components/TextField/TextField';
import Button from '../../../../components/Button/Button';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { ButtonProps } from '../../../../types';
import Header from '../../partials/Header/Header';
import Footer from '../../partials/Footer/Footer';
import { useAuth } from '../../../../contexts/AuthContext';

function LoginPage() {
    const { login, isLoading } = useAuth();
    
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const navigate = useNavigate();

    const fieldsValidated = (): boolean => {
        let error = false;
        
        if (password === '') {
            setPasswordError('Password is required');
            error = true;
        }

        if (email.indexOf('@') === -1) {
            setEmailError('Email must be valid');
            error = true;
        }

        return error;
    }

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setLoading(isLoading);

        try {
            if (fieldsValidated()) {
                return;
            }

            await login(email, password);

            navigate('/dashboard');
        } catch (err: any) {
            console.log(error);
        } finally {
            setLoading(isLoading);
            setError('');
            setEmailError('');
            setPasswordError('');

        }
    }

    const submitButtonProps: ButtonProps = {
        id: "login",
        name: "Login",
        type: "submit",
        props: {
            onClick: handleLogin
        }
    }

    return (
        <div id="login-page">
            <Header />

            <main>
                <div className="container form">
                    <div className="form-title">
                        <h2>Welcome Back!</h2>
                        <p>Log in to continue your learning journey.</p>
                    </div>

                    <LoginForm action="#" method="POST">
                        <TextField
                            id="email"
                            name="email"
                            label="Email address"
                            type="email"
                            autoComplete="email"
                            placeholder="Enter your email"
                            onChange={(e: any) => setEmail(e.target.value)}
                            value={email}
                            required
                            error={emailError}
                        />

                        <TextField
                            id="password"
                            name="password"
                            label="Password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Enter your password"
                            onChange={(e: any) => setPassword(e.target.value)}
                            value={password}
                            required
                            error={passwordError}
                        />

                        <div className="forgot-password">
                            <Link to="/forgot-password" className="link">
                                Forgot your password?
                            </Link>
                        </div>

                        <hr className="divider" />

                        <Button
                            {...submitButtonProps}
                            loading={loading}
                        />
                    </LoginForm>

                    <p className="register">
                        <span>Don't have an account?</span>
                        <Link to="/register" className="link">
                            Register
                        </Link>
                    </p>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default LoginPage;